import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Typeahead } from "react-bootstrap-typeahead";
import { useLocation, useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import "react-bootstrap-typeahead/css/Typeahead.css";
import moment from "moment";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import Select from "react-select";
import jwt_decode from "jwt-decode";
import { preventDefault } from "@fullcalendar/core/internal";
import * as constants from "../../constants/CONSTANT";
const PaymentEdit = (props) => {
    //console.log('props', props.payment)
    const [validated, setValidated] = useState(false);
    const [option, setOption] = useState();
    const [location, setLocation] = useState(useLocation());
    const navigate = useNavigate();
    const [payment, setPayment] = useState(props.payment ? props.payment.row : { parentid: props.parentid });

    const [show, setShow] = useState(true);
    const [selectedUser, setSelectedUser] = useState('');
    const [optionUsers, setOptionUsers] = useState([]);
    const [ownerList, setOwnerList] = useState([]);
    const [defaultOwner, setDefaultOwner] = useState([]);
    const [defaultTargetDate, setDefaultTargetDate] = useState(new Date());

    useEffect(() => {

        async function init() {

            //console.log('props.payment', props.payment.row.id)
            //const result = await fuziElevatorsApi.fetchPaymentById(props.payment.row.id);
            ////console.log('fetchPaymentById',result)
            //  setPayment(result)



        }
        init();
    }, []);


    const handleChange = (e) => {
        setPayment({ ...payment, [e.target.name]: e.target.value, businessid: props.parent?.id, contactid: props.parent?.contactid });
    };

    console.log('Payment Props', props)
    {/* //Added by shivani 7 aug  start*/ }
    const checkRequiredFields = () => {
        if (typeof payment.paymentdate === 'undefined' || payment.paymentdate === null) {
            payment.paymentdate = new Date().toISOString();
        }

        // Added by shivani start
        const currentAmount = parseFloat(payment.amount || "0");
        const previousAmount = props.payment?.row?.amount ? parseFloat(props.payment.row.amount) : 0;
        const maxAmount = payment.id ? props.pendingAmount + previousAmount : props.pendingAmount;

        if (payment.type && currentAmount > 0 && payment.discription) {
            return false;
        }
        // Added by shivani end
        return true;
    };



    {/* //Added by shivani 7 aug end*/ }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (checkRequiredFields()) {
            setValidated(true);
            return;
        }
        if (payment.id) {
            //console.log('edit call');
            const result = await fuziElevatorsApi.savePayment(payment);
            if (result) {
                submitpayments();
            }
        } else {
            console.log("Create time Payment", payment);
            const result = await fuziElevatorsApi.createPayment(payment);
            //console.log('result', result);

            if (result) {
                //setShow(false)
                submitpayments();
            }
        }
    };
    {/* //Added by shivani 7 aug */ }
    const submitpayments = () => {
        props.submitpayments();
    };
    const previousAmount = props.payment?.row?.amount ? parseFloat(props.payment.row.amount) : 0; {/* //Added by shivani 7 aug */ }
    const maxAmount = payment.id ? props.pendingAmount + previousAmount : props.pendingAmount; {/* //Added by shivani 7 aug */ }


    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {!payment.id ? 'Create Payment' : 'Edit Payment'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container className="view-form">
                    <Row>
                        <Col lg={12}>
                            <Form noValidate validated={validated} onSubmit={handleSubmit} controlId="paymentEdit">
                                <Row lg={12}>

                                    <Col lg={6}>
                                        <Form.Group className="mx-3" controlId="formBasicTitle">
                                            <Form.Label className="form-view-label" htmlFor="formBasicTitle">
                                                Payment Date
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                type="date"
                                                name="paymentdate"
                                                value={payment.paymentdate ? moment(payment.paymentdate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={6}>
                                        <Form.Group className="mx-3" controlId="formBasicType">
                                            <Form.Label className="form-view-label" htmlFor="formBasicType">
                                                Type
                                            </Form.Label>
                                            <Form.Select
                                                required
                                                aria-label="Enter Payment Status"
                                                name="type"
                                                value={payment.type}
                                                onChange={handleChange}
                                            >
                                                <option value="">--Select--</option>
                                                {constants.PAYMENT_TYPES.map((type, index) => (
                                                    <option key={index} value={type.value}>
                                                        {type.label}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {/* Added by Imran Khan Payment Service on AMC Ticket 1064 on 16-March-2026*/}
                                    <Col lg={6}>
                                        <Form.Group className="mx-3" controlId="formPaymentService">
                                            <Form.Label className="form-view-label" htlFor="formPaymentService">
                                            Service Type
                                            </Form.Label>

                                            <Form.Select
                                                required
                                                name="payment_service"
                                                value={payment.payment_service || ""}  
                                                onChange={handleChange}
                                            >
                                                <option value="New Lift">New Lift</option>
                                                <option value="AMC">AMC</option>
                                                <option value="Mod/Parts">Mod/Parts</option>
                                                <option value="One Time Service">One Time Service</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {/* End of Added by Imran Khan Payment Service on AMC Ticket 1064 on 16-March-2026*/}
                                    <Col lg={6}>
                                        <Form.Group className="mx-3" controlId="formBasicPriority">
                                            <Form.Label className="form-view-label" htmlFor="formBasicPriority">
                                                Amount
                                            </Form.Label>
                                            {/* Added by shivani start */}
                                            <Form.Control
                                                required
                                                type="number"
                                                name="amount"
                                                value={payment.amount}
                                                onChange={handleChange}
                                                min="1"
                                            //  max={maxAmount} //Added by shivani 7 aug
                                            //  disabled={maxAmount === 0} 
                                            />

                                            <Form.Control.Feedback type="invalid">
                                                {maxAmount === 0 ? "No payment left" : "Amount cannot be more than ₹" + maxAmount}
                                            </Form.Control.Feedback>
                                            {/* Added by shivani end */}
                                        </Form.Group>
                                    </Col>
                                    <Col lg={12}>
                                        <Form.Group className="mx-3" controlId="formBasicStatus">
                                            <Form.Label className="form-view-label" htmlFor="formBasicStatus">
                                                Remarks
                                            </Form.Label>
                                            <Form.Control
                                                required
                                                as="textarea"
                                                name="discription"
                                                value={payment.discription}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={6}>
                                        <Form.Group className="mx-3" controlId="formBasicStatus">
                                            <Form.Label className="form-view-label" htmlFor="formBasicStatus">
                                                Created Date
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                name="createddate"
                                                value={moment(payment.createddate).format('DD-MM-YYYY')}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={6}>
                                        <Form.Group className="mx-3" controlId="formBasicStatus">
                                            <Form.Label className="form-view-label" htmlFor="formBasicStatus">
                                                Last Modified Date
                                            </Form.Label>
                                            <Form.Control
                                                disabled
                                                type="text"
                                                name="lastmodifieddate"
                                                value={moment(payment.lastmodifieddate).format('DD-MM-YYYY')}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={handleSubmit}>Save</Button>
                <Button onClick={props.onHide} variant="light">Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PaymentEdit;